import Link from 'next/link'
import { Fragment, type FunctionComponent } from 'react'
import { ChevronRight } from 'lucide-react'
import { Row } from '@christiankaindl/lyts'
import Image from 'next/image'
import * as styles from './Breadcrumbs.css'
import { BreadcrumbJsonLd } from 'next-seo'
import { domain } from '@shared/lib/utils'
import Button from '@shared/components/Button/Button'

export interface BreadcrumbsProps {
  crumbs: Array<{
    title: string
    href?: string
    tooltip?: string
    tagline?: string
  }>
}

const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = function ({
  crumbs = [],
}) {
  return (
    <Row gap='1px' bleed={21} className={styles.root}>
      {crumbs.length > 1 && (
        <BreadcrumbJsonLd
          items={crumbs
            .filter((crumb) => crumb.href)
            .map((crumb) => ({
              name: crumb.title,
              item: `${domain}${crumb.href}`,
            }))}
        />
      )}
      <Link href='/' style={{ display: 'flex', marginRight: 6 }} title='Home'>
        <Image
          src='/android-chrome-192x192.png'
          width={24}
          height={24}
          alt=''
          priority
        />
      </Link>
      {crumbs.map((crumb, index) => {
        const disabled = crumb.href === undefined
        return (
          <Fragment key={`${crumb.title}/${index}`}>
            <ChevronRight size={16} style={{ opacity: 0.6 }} />
            <Button
              href={crumb.href ?? '/'}
              title={crumb.tooltip}
              disabled={disabled}
              size='small'
              variant='flat'
              style={{ fontWeight: 400 }}
            >
              <span
                style={{
                  maxWidth: '50vmax',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {crumb.title}
                {crumb.tagline && (
                  <span style={{ opacity: 0.6 }}>{` | ${crumb.tagline}`}</span>
                )}
              </span>
            </Button>
          </Fragment>
        )
      })}
    </Row>
  )
}

export default Breadcrumbs
